import { render, staticRenderFns } from "./CoRouterBase.vue?vue&type=template&id=85a09f6a&"
import script from "./CoRouterBase.vue?vue&type=script&lang=js&"
export * from "./CoRouterBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports